<div class="td-wb-w8ben-form-tax-residency-benefit">
  <div class="td-wb-w8ben-form-tax-residency-benefit__header">
    <span [attr.id]="getModalId()"
          translate="tdWb.w8BenForm.modal.taxResidencyBenefit.TITLE"></span>
  </div>

  <td-wb-notification class="td-wb-w8ben-form-tax-residency-benefit__info"
                      notificationType="info">
    <span translate="tdWb.w8BenForm.modal.taxResidencyBenefit.INFO_TEXT"></span>
  </td-wb-notification>

  @if(!submitError) {
    <td-wb-form novalidate
              autocomplete="off">
      <td-wb-form-row class="td-wb-w8ben-form-tax-residency-benefit__form-row">
        <td-wb-input-group class="td-wb-w8ben-form-tax-residency-benefit__form-input-group">
          <td-wb-input-group-label class="td-wb-w8ben-form-tax-residency-benefit__form-label">
            <label for="td-wb-w8ben-form-tax-residency">
              <span translate="tdWb.w8BenForm.modal.taxResidencyBenefit.TAX_RESIDENCY_LABEL"></span>
              <td-wb-w8ben-tooltip>
                <span translate="tdWb.w8BenForm.modal.taxResidencyBenefit.TAX_RESIDENCY_TOOLTIP"></span>
              </td-wb-w8ben-tooltip>
            </label>
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-w8ben-form-tax-residency-benefit__form-input-group-field">
            <input id="td-wb-w8ben-form-tax-residency"
                  type="text"
                  name="taxResidency"
                  tdWbInput
                  [ngModel]="taxResidency"
                  [disabled]="true">
          </td-wb-input-group-field>
        </td-wb-input-group>
      </td-wb-form-row>

      <td-wb-form-row class="td-wb-w8ben-form-tax-residency-benefit__form-row">
          <div class="td-wb-w8ben-form-tax-residency-benefit__form-label" id="td-wb-w8ben-form-benefit-label">
            <span translate="tdWb.w8BenForm.modal.taxResidencyBenefit.BENEFIT_LABEL"></span>
            <td-wb-w8ben-tooltip>
              <span translate="tdWb.w8BenForm.modal.taxResidencyBenefit.BENEFIT_TOOLTIP"></span>
            </td-wb-w8ben-tooltip>
          </div>
          <td-wb-radio-group class="td-wb-w8ben-form-tax-residency-benefit__form-selection"
                              aria-labelledby="td-wb-w8ben-form-benefit-label"
                              [(ngModel)]="specialRatesConditions"
                              tdWbInput>
            <td-wb-selectable-input-panel class="td-wb-w8ben-form-tax-residency-benefit__form-options">
              <td-wb-radio class="td-wb-w8ben-form-tax-residency-benefit__form-option"
                          name="benefit"
                          radioId="td-wb-w8ben-form-tax-residency-benefit-option-yes"
                          selectorPosition="center"
                          [value]="true">
                <span translate="tdWb.w8BenForm.modal.taxResidencyBenefit.BENEFIT_OPTION_YES"></span>
              </td-wb-radio>
              <td-wb-radio class="td-wb-w8ben-form-tax-residency-benefit__form-option"
                          name="benefit"
                          radioId="td-wb-w8ben-form-tax-residency-benefit-option-no"
                          selectorPosition="center"
                          [value]="false">
                <span translate="tdWb.w8BenForm.modal.taxResidencyBenefit.BENEFIT_OPTION_NO"></span>
              </td-wb-radio>
            </td-wb-selectable-input-panel>
          </td-wb-radio-group>
      </td-wb-form-row>
    </td-wb-form>

    <div class="td-wb-w8ben-form-tax-residency-benefit__action">
      <td-wb-divider />
      <div class="td-wb-w8ben-form-tax-residency-benefit__action-buttons">
        <button id="td-wb-w8ben-form-tax-residency-benefit-back-button"
                tdWbButton
                tdWbButtonType="secondary"
                [tdWbHref]="hasUpdates ? 'modal.w8ben.update' : 'modal.w8ben.preview'"
                [tdWbHrefParams]="hasUpdates ? { isPermanentResidence: true }: { retainData: true }">
          <span translate="tdWb.w8BenForm.modal.taxResidencyBenefit.BACK_BUTTON"></span>
        </button>
        <button tdWbButton
                [disabled]="specialRatesConditions === null"
                (click)="onClickContinue()">
          <span translate="tdWb.w8BenForm.modal.taxResidencyBenefit.CONTINUE_BUTTON"></span>
        </button>
      </div>
    </div>
  } @else {
    <td-wb-w8ben-form-error [submitError]="true" />
  }
</div>
